import { PropsWithChildren } from 'react'

import SvdContext from './svd-context'

function SvdContextProvider({ isSvdEnabled, children }: PropsWithChildren<{ isSvdEnabled: boolean }>) {
  return <SvdContext.Provider value={isSvdEnabled}>{children}</SvdContext.Provider>
}

export default SvdContextProvider
